import { ITranslationEntry } from '../lang';

export const EN: ITranslationEntry = {
  translations: {
    notifications: 'Notifications',
    markAllAsRead: 'Mark all as read',
    poweredBy: 'Powered By',
    settings: 'Settings',
  },
  lang: 'en',
};
